import { render, staticRenderFns } from "./MessageOptions.vue?vue&type=template&id=d0659876&scoped=true"
import script from "./MessageOptions.vue?vue&type=script&lang=js"
export * from "./MessageOptions.vue?vue&type=script&lang=js"
import style0 from "./MessageOptions.vue?vue&type=style&index=0&id=d0659876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0659876",
  null
  
)

export default component.exports